(function () {
  const show = (el) => el.classList.add('is-visible');

  const isInView = (el) => {
    const rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight * 0.92 && rect.bottom > 0;
  };

  const initReveal = (root) => {
    const scope = root && root.querySelectorAll ? root : document;
    const revealNodes = scope.querySelectorAll('.zzai-reveal:not(.is-visible)');
    if (!revealNodes.length) return;

    if (!('IntersectionObserver' in window)) {
      revealNodes.forEach(show);
      return;
    }

    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            show(entry.target);
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.05, rootMargin: '0px 0px -24px 0px' }
    );

    revealNodes.forEach((el) => {
      if (isInView(el)) {
        show(el);
      } else {
        revealObserver.observe(el);
      }
    });
  };

  initReveal(document);

  document.addEventListener('shopify:section:load', (event) => {
    initReveal(event.target);
  });
})();
